module.exports = __webpack_public_path__ + "static/img/ico13.71d1710b.svg";